import withQuillLayout from 'src/_common/hoc/QuillLayout';
import Privacy from 'src/mics/components/Privacy';
import PrivacyDE from 'src/mics/components/PrivacyDE';
import { useRouter } from 'next/router';

const PrivacyPolicy = () => {
  const router = useRouter();
  const gcLanguage = router.query.language;

  return gcLanguage === 'DE' ? <PrivacyDE /> : <Privacy />;
};

export default withQuillLayout({
  children: PrivacyPolicy,
});
